/* eslint-disable */
// firebase functions
import { db, str } from "@/services/firebase";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { createStore } from "vuex";

import emailjs from "@emailjs/browser";

//for state management
import userflow from "./userflow";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

//composables
import { formatDate } from "@/composables/forDate";
import { Client, ID, Storage } from "appwrite";
import appWriteConfig from "@/services/appwrite";
const { date } = formatDate("format");

export default createStore({
  state: {
    users: [],
    shipments: [],

    loading: {
      shipment: false,
      delete: false,
    },
  },
  getters: {
    getState: (state) => (value) => {
      return state[value];
    },
    getLoading(state) {
      return state.loading;
    },
    getShipment: (state) => (id) => {
      return state.shipments.find((shipment) => shipment.id == id);
    },
  },
  mutations: {
    setState(state, { type, value }) {
      state[type] = value;
    },
    setLoading(state, { type, is }) {
      state.loading[type] = is;
    },
  },
  actions: {
    async photoFN(context, { photo, path }) {
      const uniqueID = ID.unique();

      const { str_id, endpoint, project_id } = appWriteConfig;

      const client = new Client()
        .setEndpoint(endpoint) // Set the API endpoint
        .setProject(project_id); // Set the project ID

      // Ensure `client` is initialized correctly before passing it
      if (!client) {
        throw new Error("Client is not initialized");
      }

      // Create a new Storage instance
      const storage = new Storage(client);

      try {
        // Create a new file
        const createFileFN = await storage.createFile(str_id, uniqueID, photo);

        // Get the file view URL
        const url = storage.getFileView(str_id, uniqueID);

        return url;
      } catch (error) {
        commit("setLoading", { type: "deposit", is: false });
        console.error("Error creating file or retrieving URL:", error);
        userflow.dispatch("initAlert", {
          type: "error",
          timer: 10000,
          is: true,
          message: error.code,
        });
        throw error; // Ensure errors are handled properly
      }
    },

    async initAllUsers({ commit }) {
      const colref = collection(db, "users");

      await getDocs(colref)
        .then((docRefs) => {
          if (!docRefs.empty) {
            const arr = [];
            docRefs.forEach((docs) => {
              arr.push(docs.data());
            });

            commit("setState", { type: "users", value: arr });
          } else {
            commit("setState", { type: "users", value: [] });
          }
        })
        .catch((error) => {
          userflow.dispatch("initAlert", {
            type: "error",
            is: true,
            message: error.code,
            timer: 7000,
          });
        });
    },

    async editShipment({ commit, dispatch }, payload) {
      commit("setLoading", { type: "shipment", is: true });
      const colref = collection(db, "shipments");

      if (payload.passportP) {
        const passportPhoto = await dispatch("photoFN", {
          photo: payload.passportPhoto,
          path: "shipments",
        });
        payload.passportPhoto = passportPhoto;
      }

      if (payload.shipmentP) {
        const shipmentPhoto = await dispatch("photoFN", {
          photo: payload.shipmentPhoto,
          path: "shipments",
        });

        payload.shipmentPhoto = shipmentPhoto;
      }

      const currentUserDoc = doc(colref, payload.id);

      await updateDoc(currentUserDoc, payload)
        .then(() => {
          userflow.dispatch("initAlert", {
            type: "success",
            is: true,
            message: `Shipment For ${payload.fullName} Updated Successfully`,
            close: true,
            timer: 6000,
          });
          dispatch("initAllShipments");
          commit("setLoading", { type: "shipment", is: false });
        })
        .catch((error) => {
          userflow.dispatch("initAlert", {
            type: "error",
            is: true,
            message: error.code,
            timer: 7000,
          });
          commit("setLoading", { type: "shipment", is: false });
        });
    },

    async addShipment({ commit, dispatch }, payload) {
      commit("setLoading", { type: "shipment", is: true });

      const colref = collection(db, "shipments");

      const passportPhoto = await dispatch("photoFN", {
        photo: payload.passportPhoto,
        path: "shipments",
      });

      payload.passportPhoto = passportPhoto;

      const shipmentPhoto = await dispatch("photoFN", {
        photo: payload.shipmentPhoto,
        path: "shipments",
      });

      payload.shipmentPhoto = shipmentPhoto;

      //added prop to arrange array
      payload.formattedDate = date;
      payload.status = "Ongoing";

      let trackingCode = "";

      function getTrackingCode() {
        for (let index = 0; index < 6; index++) {
          let rando = Math.round(Math.random() * 9);
          trackingCode += rando.toString();
        }
        return trackingCode;
      }

      payload.trackingCode = getTrackingCode();
      payload.progress = "10";

      await addDoc(colref, payload)
        .then(async (docRef) => {
          const currentUserDoc = doc(colref, docRef.id);

          updateDoc(currentUserDoc, {
            id: docRef.id,
          })
            .then(async () => {
              userflow.dispatch("initAlert", {
                type: "success",
                message: "Shipment Created Successfully",
                is: true,
                close: true,
                timer: 5000,
              });

              await emailjs
                .send(
                  "service_u0hdcut",
                  "template_cyiybo9",
                  {
                    name: payload.fullName,
                    email: payload.email,
                    tracking_number: payload.trackingCode,
                    carrier: "Costar Shippers Logistics",
                    current_location: payload.location,
                    status: "Ongoing",
                    due_date: payload.dueDate,
                  },
                  "8kFc5I2Pnjyccsegl"
                )
                .then(() => {
                  console.log("Mail Sent");
                });

              this.dispatch("initAllShipments");

              commit("setLoading", { type: "shipment", is: false });
            })
            .catch((error) => {
              userflow.dispatch("initAlert", {
                type: "error",
                is: true,
                message: error.code,
                timer: 7000,
              });
            });
          commit("setLoading", { type: "shipment", is: false });
        })
        .catch((error) => {
          userflow.dispatch("initAlert", {
            type: "error",
            is: true,
            message: error.code,
            timer: 7000,
          });
          commit("setLoading", { type: "shipment", is: false });
        });
    },

    async initAllShipments({ commit }) {
      const colref = collection(db, "shipments");

      await getDocs(colref)
        .then((docRefs) => {
          if (!docRefs.empty) {
            const arr = [];
            let sorting;
            docRefs.forEach((docs) => {
              arr.push(docs.data());

              sorting = arr.sort((a, b) => {
                const dateA = new Date(a.formattedDate);
                const dateB = new Date(b.formattedDate);

                return dateB - dateA;
              });
            });
            commit("setState", { type: "shipments", value: sorting });
          } else {
            commit("setState", { type: "shipments", value: [] });
          }
        })
        .catch((error) => {
          userflow.dispatch("initAlert", {
            is: true,
            message: error.code,
            type: "error",
            timer: 5000,
          });
        });
    },

    async deleteShipment(context, payload) {
      this.commit("setLoading", { type: "delete", is: true });

      const currentUserDoc = doc(db, "shipments", payload.id);

      await deleteDoc(currentUserDoc)
        .then(() => {
          userflow.dispatch("initAlert", {
            is: true,
            message: `Shipment for ${payload.fullName} Deleted Successfully`,
            type: "error",
            close: true,
            timer: 6000,
          });
          this.commit("setLoading", { type: "delete", is: false });
          this.dispatch("initAllShipments");
        })
        .catch((error) => {
          userflow.dispatch("initAlert", {
            type: "error",
            timer: 6000,
            message: error.code,
            is: true,
          });
          this.commit("setLoading", { type: "delete", is: false });
        });
    },

    async initApp() {
      await this.dispatch("initAllUsers");
      await this.dispatch("initAllShipments");
    },
  },
  modules: {},
});
